import React from "react";
import paths from "./howToUseIconPaths.json";

export const howToUseIconKeys = Object.keys(paths);

// Original, shared 64-unit line drawings. Adjacent text supplies the meaning.
export default function HowToUseIcon({ iconKey }) {
  if (!paths[iconKey]) return null;
  return <svg className="pds-step-icon" viewBox="0 0 64 64" width="52" height="52"
    fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true" focusable="false" data-icon={iconKey}>
    <path d={paths[iconKey]} />
  </svg>;
}
